import { jsx as _jsx } from "react/jsx-runtime";
import { observer } from 'mobx-react';
import { useOccContext } from '../../../context/occ/hooks/use-occ-context';
import { Icon } from '../../icon/icon';
/**
 * Renders an svg placeholder
 */
export const ImagePlaceholder = observer(props => {
    const { placeholderAssets } = useOccContext();
    const { type, className } = props;
    const iconAsset = placeholderAssets[type];
    if (!iconAsset)
        throw new Error(`Cannot find placeholder asset for ImagePlaceholderType: '${type}'.`);
    /**
     * Inline svg does not scale well in browsers other than Firefox and blink.
     * https://css-tricks.com/scale-svg/#article-header-id-9
     *
     * Workaround: set paddingBottom percentage to control aspect.
     */
    return (_jsx(Icon, { className: className, name: iconAsset.name, viewBox: iconAsset.viewBox, preserveAspectRatio: "xMidYMid slice" }));
});
ImagePlaceholder.displayName = 'ImagePlaceholder';
